import axios from 'axios';

const API_URL = '/accounts/employees';

/**
 * Get all employees
 */
const getEmployees = async (params = {}) => {
  const response = await axios.get(`${API_URL}/`, { params });
  return response.data;
};

/**
 * Get employee by ID
 */
const getEmployee = async (id) => {
  const response = await axios.get(`${API_URL}/${id}/`);
  return response.data;
};

const employeeService = {
  getEmployees,
  getEmployee,
};

export default employeeService;